export const REMOVE_GLOBAL_FILTERS = 'REPORTING_REMOVE_GLOBAL_FILTERS';

export const FILTER_TYPES = {
  THEMATIC: 'thematic',
  NORMAL: 'normal',
};

export const removeGlobalFilters = (filterType, filterValues) => ({
  type: REMOVE_GLOBAL_FILTERS,
  filterType,
  filterValues,
});
